export function Genre(props) {
    return (
        <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '350px',
            padding: '10px 15px',
            margin: '5px 0',
            backgroundColor: '#fff',
            borderRadius: '8px',
            boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
            border: '1px solid #eee'
        }}>
            <span style={{ fontSize: '16px', fontWeight: '500', color: '#333' }}>
                {props.genre.name}
            </span>
            <button
                onClick={() => props.onDeleteClicked(props.genre)}
                style={{
                    backgroundColor: '#fee2e2',
                    color: '#ef4444',
                    border: 'none',
                    borderRadius: '6px',
                    padding: '5px 10px',
                    cursor: 'pointer',
                    fontSize: '12px',
                    fontWeight: 'bold',
                    transition: '0.2s'
                }}
                onMouseOver={(e) => e.target.style.backgroundColor = '#f6a1a1'}
                onMouseOut={(e) => e.target.style.backgroundColor = '#fee2e2'}
            >
                Видалити
            </button>
        </div>
    );
}